{
    "local": {
        "ADMIN_URL": "https://sketch-uat.viewspection.com/admin/api/",
        "VSP_URL": "https://uatweb.viewspection.com/api/"
    },
    "dev": {
        "ADMIN_URL": "https://sketch-uat.viewspection.com/admin/api/",
        "VSP_URL": "https://uatweb.viewspection.com/api/"
    },
    "prod": {
        "ADMIN_URL": "https://sketch.viewspection.com/admin/api/",
        "VSP_URL": "https://web.viewspection.com/api/"
    }
}